"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NumberFormat_1 = require("./NumberFormat");
var Constant_1 = require("../utils/Constant");
var NumberFormatFactory = /** @class */ (function () {
    function NumberFormatFactory() {
        this.pool = new Map();
        // 构建完后预留164个内置id（0 ~ 163）
        this.maxId = Constant_1.RESERVED_NUMBER_FORMAT_NUM;
    }
    NumberFormatFactory.prototype.createInstance = function (options) {
        var id = options.id, pattern = options.pattern;
        var instance;
        if (typeof pattern === 'string' && !!pattern) {
            instance = this.pool.get(pattern);
            if (instance) {
                return instance;
            }
            id = Constant_1.BUILDIN_NUMBER_FORMAT.indexOf(pattern);
            if (id === -1) {
                id = this.maxId;
                this.maxId += 1;
            }
            instance = this.addNumberFormatToPool(id, pattern);
            return instance;
        }
        if (typeof id === 'number' && !isNaN(id)) {
            instance = this.pool.get(id);
            if (instance) {
                return instance;
            }
            if (id < Constant_1.BUILDIN_NUMBER_FORMAT.length) {
                pattern = Constant_1.BUILDIN_NUMBER_FORMAT[id];
                instance = this.addNumberFormatToPool(id, pattern);
            }
            else {
                // 越界id，没传pattern，返回general
                instance = this.getDefaultNumberFormat();
            }
            return instance;
        }
        return this.getDefaultNumberFormat();
    };
    NumberFormatFactory.prototype.clear = function () {
        this.pool = new Map();
    };
    NumberFormatFactory.prototype.getDefaultNumberFormat = function () {
        var instance = this.pool.get(0);
        if (!instance) {
            instance = this.addNumberFormatToPool(0, Constant_1.DEFAULT_FORMAT_PATTERN);
        }
        return instance;
    };
    NumberFormatFactory.prototype.addNumberFormatToPool = function (id, pattern) {
        var instance = new NumberFormat_1.NumberFormat({
            id: id,
            pattern: pattern,
        });
        this.pool.set(id, instance);
        this.pool.set(pattern, instance);
        return instance;
    };
    return NumberFormatFactory;
}());
exports.default = new NumberFormatFactory();
//# sourceMappingURL=NumberFormatFactory.js.map